// First-party, cookie-less analytics. No third parties, fire-and-forget.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function visitorId() {
  let vid = localStorage.getItem("app_vid");
  if (!vid) {
    vid = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    localStorage.setItem("app_vid", vid);
  }
  return vid;
}

let _last = { key: "", t: 0 };

export function track(event, path, meta = {}) {
  try {
    const p = path || window.location.pathname;
    if (p.startsWith("/admin") || navigator.webdriver) return;
    // dedupe: React StrictMode double-invokes mount effects in dev
    const key = `${event}|${p}`;
    const now = Date.now();
    if (key === _last.key && now - _last.t < 1000) return;
    _last = { key, t: now };
    const payload = { event, path: p, vid: visitorId(), width: window.innerWidth, meta };
    if (event === "pageview") payload.referrer = document.referrer || "";
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // tracking must never break the app
  }
}
